import { render, staticRenderFns } from "./RegistrationInfoModal.vue?vue&type=template&id=1a7f3182&scoped=true&"
import script from "./RegistrationInfoModal.vue?vue&type=script&lang=ts&"
export * from "./RegistrationInfoModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7f3182",
  null
  
)

export default component.exports